import { ContractAction } from "./action";
import { ContractInterface, initContractState } from "./state";

export function ContractReducer(state: ContractInterface = initContractState, action: ContractAction): ContractInterface {
    switch (action.type) {
        case '@@Contract/changeContractName':
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    contract: action.contractName
                }
            }

        case '@@Contract/handleChangeContractIsActiveAction':
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    is_active: action.is_active
                }
            }

        case '@@Contract/handleChangeContractNeedInspectAction':
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    need_inspect: action.need_inspect
                }
            }

        case '@@Contract/handleChangeContractImageTypeIdAction':
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    image_type_id: action.image_type_id
                }
            }

        case '@@Contract/handleChangeContractReportTitleAction':
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    report_title: action.report_title
                }
            }

        case '@@Contract/handleSetContractZoneListAction':
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    zoneList: action.zoneList
                }
            }

        case '@@Contract/handleChangeContractZoneFieldAction': {
            const zoneList = (state.Contract.zoneList || []).map((zone, idx) =>
                idx === action.index
                    ? { ...zone, [action.field]: action.value }
                    : zone
            );
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    zoneList
                }
            }
        }

        case '@@Contract/handleAddContractZoneAction': {
            const zoneList = state.Contract.zoneList || [];
            const nextSeq = zoneList.length > 0
                ? Math.max(...zoneList.map(z => z.contract_report_sequence || 0)) + 1
                : 1;
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    zoneList: [
                        ...zoneList,
                        {
                            zone_name: '',
                            report_zone_name: '',
                            contact_person: '',
                            tel: '',
                            email: '',
                            contract_report_sequence: nextSeq,
                            bin_count: 0,
                        },
                    ],
                },
            };
        }

        case '@@Contract/handleInitEditContractAction':
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    contract: action.contract.contract,
                    is_active: action.contract.is_active,
                    need_inspect: action.contract.need_inspect?.toString() || '1',
                    contract_id: action.contract.contract_id.toString(),
                    image_type_id: action.contract.image_type_id || '',
                    report_title: action.contract.report_title || '',
                    zoneList: [],
                    imageTypeList: []
                }
            }

        case '@@Contract/clearContractDataAction':
            return {
                ...state,
                Contract: {
                    contract: "",
                    is_active: "1",
                    need_inspect: "1",
                    contract_id: "",
                    image_type_id: "",
                    report_title: "",
                    zoneList: [],
                    imageTypeList: []
                }
            }

        case '@@Contract/handleSetImageTypeListAction':
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    imageTypeList: action.imageTypeList
                }
            }

        case '@@Contract/handleAddImageTypeAction':
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    imageTypeList: [...(state.Contract.imageTypeList || []), action.imageType]
                }
            }

        case '@@Contract/handleUpdateImageTypeAction': {
            const imageTypeList = (state.Contract.imageTypeList || []).map((item, idx) =>
                idx === action.index ? action.imageType : item
            );
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    imageTypeList
                }
            }
        }

        case '@@Contract/handleRemoveImageTypeAction': {
            const imageTypeList = (state.Contract.imageTypeList || []).filter((_, idx) => idx !== action.index);
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    imageTypeList
                }
            }
        }

        case '@@Contract/handleMoveImageTypeAction': {
            const imageTypeList = [...(state.Contract.imageTypeList || [])];
            const targetIndex = action.direction === 'up'
                ? action.index - 1
                : action.index + 1;
            if (targetIndex < 0 || targetIndex >= imageTypeList.length) {
                return state;
            }
            [imageTypeList[action.index], imageTypeList[targetIndex]] = [
                imageTypeList[targetIndex],
                imageTypeList[action.index],
            ];
            return {
                ...state,
                Contract: {
                    ...state.Contract,
                    imageTypeList
                }
            }
        }

        case '@@Contract/handleOpenAddZoneDialogAction':
            return {
                ...state,
                openAddZoneDialog: true
            }

        case '@@Contract/handleCloseAddZoneDialogAction':
            return {
                ...state,
                openAddZoneDialog: false
            }

        default:
            return state;
    }
}
